import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import { queryClient } from '~/lib/react-query';
import { theme } from '~/styles/theme';
import { AppRoutes } from '~/routes';
import { ErrorFallback } from '~/components/ErrorFallback';
import { LoadingSpinner } from '~/components/LoadingSpinner';
import keycloak from './shared/guards/Keycloak';
export function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <SnackbarProvider
              maxSnack={3}
              preventDuplicate={true}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              autoHideDuration={3500}
            >
              <ReactKeycloakProvider
                authClient={keycloak}
                initOptions={{
                  // Allow public routes without forcing login; private routes enforce auth.
                  onLoad: 'check-sso',
                  // PKCE S256 needs crypto.subtle (HTTPS only); disabled on HTTP QA hosts.
                  pkceMethod: globalThis.isSecureContext ? 'S256' : false,
                  checkLoginIframe: false,
                }}
              >
                <BrowserRouter>
                  <Suspense fallback={<LoadingSpinner />}>
                    <AppRoutes />
                  </Suspense>
                </BrowserRouter>
              </ReactKeycloakProvider>
            </SnackbarProvider>
          </LocalizationProvider>
        </ThemeProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
